import { render } from "./groupObjectives.vue?vue&type=template&id=07133e9f&scoped=true"
import script from "./groupObjectives.vue?vue&type=script&lang=js"
export * from "./groupObjectives.vue?vue&type=script&lang=js"

import "./groupObjectives.vue?vue&type=style&index=0&id=07133e9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07133e9f"]])

export default __exports__